export enum FormasPagamento {
    'PixInserirCredito' = 0,
    'CartaoCredito' = 1,
    'Saldo' = 3,
    'AuxilioEmergencial' = 4,
    'Pix' = 6,
}